import { useEffect, useState } from 'react';
import { apiFetch } from '../network';

function normalizeAvailabilityBlocks(payload) {
  if (Array.isArray(payload?.availabilityBlocks)) {
    return payload.availabilityBlocks;
  }

  return [];
}

export function useAvailabilityBlocks() {
  const [availabilityBlocks, setAvailabilityBlocks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  const refreshAvailabilityBlocks = async () => {
    setLoading(true);
    setError(false);

    try {
      const response = await apiFetch('/disponibilites/get');

      if (!response.ok) {
        throw new Error('request_failed');
      }

      const data = await response.json();
      setAvailabilityBlocks(normalizeAvailabilityBlocks(data));
    } catch (requestError) {
      setAvailabilityBlocks([]);
      setError(true);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    refreshAvailabilityBlocks();
  }, []);

  return {
    availabilityBlocks,
    loading,
    error,
    refreshAvailabilityBlocks
  };
}
